<template>
    <div class="menu-horizontal" :id="id">
        <div class="menu-horizontal-header">
            <div class="menu-horizontal-title">
                {{ title }}
            </div>
            <router-link :to="{ name: 'menu-single', params: { id } }" class="menu-horizontal-see-all">
                 {{ $t("pages.menu.blocks.categories.action") }}
            </router-link>
        </div>
        <ul class="menu-horizontal-ul">
            <MenuItemHorizontal v-for="item in items" :item="item" :key="item.id" />
        </ul>
    </div>

</template>

<script>
import MenuItemHorizontal from './MenuItemHorizontal.vue';

export default {
    name: "MenuHorizontalScroll",
    components: {
        MenuItemHorizontal,
    },
    props: {
        id: { type: String, required: true },
        title: { type: String, required: true },
        items: { type: Array, required: true },
    },
    data() {
        return {
        };
    },
}
</script>

<style lang="scss" scoped>
ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.menu-horizontal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 20px 16px 14px;

    .menu-horizontal-title {
        font-weight: var(--weight-black);
        font-size: var(--text-2xl);
        line-height: 1.1;

        color: var(--text-primary);
    }

    .menu-horizontal-see-all {
        font-weight: var(--weight-bold);
        font-size: 14px;
        line-height: 1;
        text-align: end;

        color: var(--color-primary);
        text-decoration: none;
    }
}

.menu-horizontal-ul {
    display: flex;
    gap: 12px;

    padding: 0 16px 4px;

    overflow-x: auto;
    scrollbar-width: none;
}
</style>